import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=b14f823a&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"
import style0 from "./channel.vue?vue&type=style&index=0&id=b14f823a&prod&lang=stylus&scoped=true"
import style1 from "./channel.vue?vue&type=style&index=1&id=b14f823a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14f823a",
  null
  
)

export default component.exports